import { Dropdown, Tag } from 'antd';
import React from 'react';
import { FormattedDate, FormattedNumber, injectIntl } from 'react-intl';
import { useSelector } from 'react-redux';
import { ForEach } from '../../../shared/components';
import CurrencyFormat from '../../../shared/components/dataDisplay/CurrencyFormat';
import ActivityElement from './activityElement';
import { generatePath, useHistory, useParams } from 'react-router-dom';


function Encargo({
  intl, menuAdvise, deviceMobile, setModalAdvise, data,
}:any) {
  const history = useHistory();
  const promociones = useSelector((state: any) => state.core.promociones);
  const encargo = { ...data, promocion: promociones.find((promo: any) => promo.id === data.promocion_id) };

  const {
    fecha_emision, tienda: { id: idTienda, nombre: nombreTienda }, promoventa_id, id, promocion, total, total_pendiente, estado, promocion_gafas,
  } = encargo;
  let stateColor = '#E6F7FF';
  let stateTextColor = '#049BDD';
  let stateBordercolor = '#91D5FF';
  switch (estado) {
    case 'PENDIENTE':
    case 'PDTE STOCK':
      stateColor = '#E6F7FF';
      stateBordercolor = '#91D5FF';
      stateTextColor = '#049BDD';
      break;
    case 'DEVOLUCION':
    case 'ANULADO':
    case 'TALLER':
      stateColor = '#F6FFED';
      stateBordercolor = '#B7EB8F';
      stateTextColor = '#00AC70';
      break;
  }
  const header = (
    <>
      <span className="dateNPlace">
        {fecha_emision}
        {' '}
        /
        {' '}
        { nombreTienda }
      </span>
      <div className="flexRow">
        <Tag style={{ color: stateTextColor, borderColor: stateBordercolor }} color={stateColor}>{estado}</Tag>
      </div>
      <p 
        className="promoCard blueLink"  
        // onClick={() => history.push(generatePath("/encargos/:encargoId/tienda/:tiendaId/mostrar", { encargoId: id, tiendaId: idTienda }))}
      >
        {
          false ? (
            <>
              {promocion_gafas ? promocion.nombre : intl.formatMessage({ id: 'pacientes.activity.without_promotion' })}
              Nº
              {' '}
              {promocion_gafas ? promoventa_id : id}
            </>
          ) : (
            <>
              Nº {id}
            </>
          )
        }
      </p>
    </>
  );
  return (
    <ActivityElement titleTraductionId="pacientes.activity.order" headerContent={header}>
      <div className="flexRow flexEnd">
        <div className="flexColumn alignRight">
          <span>{intl.formatMessage({ id: 'pacientes.client_file.total' })}</span>
          <span className="price"><CurrencyFormat value={total || 0} /></span>
        </div>
        <div className="flexColumn alignRight">
          <span>{intl.formatMessage({ id: 'pacientes.client_file.pending' })}</span>
          <span className="price pending"><CurrencyFormat value={total_pendiente || 0} /></span>
        </div>
      </div>
      { false
      && (
      <div className="flexRow botLinks">
        <Dropdown overlay={menuAdvise} trigger={['click']} disabled={deviceMobile}>
          <div className="advise" onClick={() => (deviceMobile ? setModalAdvise(true) : null)}>
            <p className="blueLink">{intl.formatMessage({ id: 'pacientes.client_file.advise' })}</p>
          </div>
        </Dropdown>
        <p className="verticalBar">|</p>
        <div className="documents">
          <p className="blueLink">
            {intl.formatMessage({ id: 'pacientes.activity.documents' })}
          </p>
        </div>
      </div>
      )
      }
    </ActivityElement>
  );
}
export default injectIntl(Encargo);
